/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// export const environment = {
//   production: true,
//   apiBaseUrl: 'https://stage-cmis5api.anudip.org/',
//   authBaseUrl: 'https://stage-cmis5api.anudip.org/auth',
//   s3BucketUrl: 'https://cmis4storage.blr1.cdn.digitaloceanspaces.com/',
// };

// export const environment = {
//   production: true,
//   apiBaseUrl: 'https://cmis5api.anudip.org/',
//   authBaseUrl: 'https://cmis5api.anudip.org/auth',
//   s3BucketUrl: 'https://cmis4storage.blr1.cdn.digitaloceanspaces.com/',
// };

export const environment = {
  production: true,
  apiBaseUrl: 'https://cmis5oldapi.anudip.org/',
  authBaseUrl: 'https://cmis5oldapi.anudip.org/auth',
  s3BucketUrl: 'https://cmis4storage.blr1.cdn.digitaloceanspaces.com/',
};